export default __webpack_public_path__ + "static/media/SeaLife_16.27230c49.png";